export const environment = {
  production: false,
  apiUrl: './Api',
  throwOnQpdErrors: true
};
